/* eslint-disable max-len */
import React, { useEffect, useMemo, useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { UIInput } from '@tencent/dz-bricks-ui';
import { MessageMsgFrom, MessageType, usePartialState } from '@tencent/dz-models';
import { useConsultModel, useMessageModel } from '../../../hooks';
import { useReportService } from './useReportService';
import styles from './style/index.less';
import { MenuItemType } from '../../../const';
import BottomModal from './bottomModal';
import { usePageModel } from '@tencent/dz-runtime';
export var BlockBottomSend = function () {
    var _a = useComponents(), View = _a.View, Image = _a.Image, Text = _a.Text;
    var messageModel = useMessageModel();
    var consultModel = useConsultModel();
    var _b = useState(messageModel.inputMessage), messageVal = _b[0], setMessageVal = _b[1];
    // 是否是首条消息
    var _c = useState(true), firstMsg = _c[0], setFirstMsg = _c[1];
    var report = useReportService();
    var showImageSend = !consultModel.getConsultConfig().forbid_picture_msg;
    var model = usePageModel();
    var _d = useState(false), isMenuOpen = _d[0], setIsMenuOpen = _d[1];
    var _e = usePartialState(function () { return model.getConsultModel(); }), consultInstance = _e[1];
    var adAuditNum = consultInstance.getConsultConfig().ad_audit_certificate;
    // 判断是否有咨询，如果没有显示top border
    var showConsult = useMemo(function () {
        var consultMenu = consultModel.consult.consult_menu;
        if (!consultModel.isFullSearch()) {
            // 非全屏咨询页，不需要去官网类型的自助咨询
            consultMenu = consultMenu.filter(function (item) { return item.item_type !== MenuItemType.goWeb; });
        }
        var enableMenu = consultModel.getConsultConfig().menu_enable;
        if (enableMenu !== 0 && consultMenu && consultMenu.length > 0) {
            return true;
        }
        return false;
    }, []);
    useEffect(function () {
        document.addEventListener('keypress', function (e) {
            // 监听发送框的keypress事件
            if (e.target.className.includes('chat-input')) {
                if (e.keyCode === 13) {
                    handleSend();
                }
            }
        });
    }, []);
    useEffect(function () {
        // 险提示，只有第一次状态变化的时候提示
        var isSearchConsult = consultModel.isSearchConsult();
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var platform_type = consultModel.getConsultConfig().platform_type;
        if (isSearchConsult && !firstMsg && platform_type !== 21) {
            messageModel.pushMessage({
                type: MessageType.MedicaleTips,
                msg_from: MessageMsgFrom.Server,
                payload: {
                    message: '如需医生专业建议/专业医疗诊断，请到院咨询',
                },
            });
        }
        if ((platform_type === 21 && !firstMsg) || (platform_type === 28 && !firstMsg)) {
            messageModel.pushMessage({
                type: MessageType.MedicaleTips,
                msg_from: MessageMsgFrom.Server,
                payload: {
                    message: '· 如需医生专业建议/专业医疗诊断，请到院咨询\n· 您可阅读{text}，了解本服务相关信息',
                },
            });
        }
        ;
    }, [firstMsg]);
    useEffect(function () {
        setMessageVal(messageModel.inputMessage);
    }, [messageModel.inputMessage]);
    var handleSend = function () {
        if (!messageModel.inputMessage)
            return;
        messageModel.sendMessage(messageModel.inputMessage);
        report.sendBtnClick();
        setMessageVal('');
        messageModel.updateInputMessage('', false);
        firstMsg && setFirstMsg(false);
    };
    var handleChange = function (value) {
        setMessageVal(value);
        messageModel.updateInputMessage(value, false);
    };
    var handleFocus = function () { return messageModel.setIsTyping(true); };
    var handleBlur = function () { return messageModel.setIsTyping(false); };
    var onShowModal = function () {
        isMenuOpen ? setIsMenuOpen(false) : setIsMenuOpen(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { className: styles['chat-send-wrapper'] },
            React.createElement(React.Fragment, null,
                React.createElement(View, { className: styles['chat-send-container'] + " " + (!showConsult && styles['chat-send-container-border']) + " " },
                    showImageSend && (React.createElement(View, { onClick: onShowModal },
                        React.createElement(Image, { src: isMenuOpen ? 'https://leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/close.png' : '//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/addimg.png', imageWidth: 25, imageHeight: 25, className: styles['chat-send-img-btn'] }))),
                    React.createElement(UIInput, { placeholder: "\u8BF4\u70B9\u4EC0\u4E48", onChange: handleChange, value: messageVal, onFocus: handleFocus, onBlur: handleBlur, className: "chat-input " + styles['chat-send-input'], id: "message-input" }),
                    React.createElement(View, { className: styles['chat-send-button'], onClick: handleSend }, "\u53D1\u9001")),
                React.createElement(Text, { style: { color: 'rgb(0,0,0, 0.3)', fontSize: 12, textAlign: 'center', backgroundColor: '#fff', paddingBottom: '8px' }, content: adAuditNum })),
            React.createElement(View, { className: "chat-container" }, isMenuOpen && (React.createElement(BottomModal, { firstMsg: firstMsg, isMenuOpen: isMenuOpen, setFirstMsg: setFirstMsg, setIsMenuOpen: setIsMenuOpen }))))));
};
